import { useState, useCallback, useEffect } from 'react'

const STORAGE_KEY = 'ea_recent_modules'
const MAX_ENTRIES = 5

/**
 * Track recently visited modules in sessionStorage.
 * Max 5 entries, deduplicated by path, no sensitive data stored.
 */
export function useRecentModules() {
  const [recentModules, setRecentModules] = useState(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  const recordVisit = useCallback((path, name) => {
    if (!path || !name) return
    console.log(`[RecentModules] Recording visit to: ${name} (${path})`)
    const cleanPath = path.split('?')[0].split('#')[0]

    setRecentModules(prev => {
      const filtered = prev.filter(m => m.path !== cleanPath)
      const updated = [{ path: cleanPath, name }, ...filtered].slice(0, MAX_ENTRIES)
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updated)) } catch { /* silent */ }
      return updated
    })
  }, [])

  const clearRecent = useCallback(() => {
    setRecentModules([])
    try { sessionStorage.removeItem(STORAGE_KEY) } catch { /* silent */ }
  }, [])

  return { recentModules, recordVisit, clearRecent }
}

export default useRecentModules
